/**
 * @desc 获取作业点评信息
 * @author: Kody
 */
import Api from '../../path';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export interface IInput {
    homework_ids: string; // string, 多个用逗号隔开
}

export interface IFeedbackInfo {
    feedback_num: number; // 点评数
    current_user_feedback_id: number; // 当前用户对该作业点评的 id，如果没点评过返回 0
    first_feedback_use_info: IUserBaseInfo; // 第一个点评的人
}

export interface IOutput {
    [nane: string]: IFeedbackInfo;
}

export const getHomeworksStat = fetchDataSync((data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.GET_HOMEWORKS_STAT, data).then((res: IResponse<IOutput>) => {
        return res;
    });
});
